import './index.css'
import { useState } from "react";

function Button({text,addedFunction,smallBool,params,image, id}){
    const [loadingState,setLoadingState] = useState(false);
    const handleClick = async () => {
      if(loadingState===false){
      try {
        setLoadingState(true);
        await addedFunction(params);
        setLoadingState(false);
      } catch (error) {
        console.error("An error occurred:", error);
        setLoadingState(false);
      }
    }
    };
    return <div className={smallBool ? 'button tiny-text' : 'button small-text'} onClick={handleClick} id={id ? id : null}>
    <img id="loading-gif" src="./images/loading.gif" alt="loading" style={{display : loadingState ? 'block' : 'none' }}></img>   
    <div style={{display : loadingState ? 'none' : 'flex' }} className='button-contents'>
    <img src={image} style={{display : image ? 'block' : 'none'}}/>
    <div>{text}</div>
    </div>
    </div>
}

export default Button